import { Table, TableProps } from '@chakra-ui/react'

export default Table
export type { TableProps }
